import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useEffect } from "react";
import { BrowserCompatibilityBanner } from "@/components/BrowserCompatibilityBanner";
import { env } from "@/env";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { captureAttributionFromUrl } from "@/lib/attribution";

interface MyRouterContext {
	queryClient: QueryClient;
	get_token: () => Promise<string | null>;
}

function RootComponent() {
	const isMobile = useIsMobile();

	// Marketing attribution is captured here, on the app's first mount, because
	// this is the earliest point that runs before the user is handed to Clerk —
	// and Clerk redirects back to `/app/select-organization` with the query
	// string gone. Capture is first-write-wins and empty-safe, so re-running it
	// on a remount cannot erase a real bundle.
	useEffect(() => {
		captureAttributionFromUrl(window.location.search);
	}, []);
	// Devtools overlap the mobile bottom tab bar, so keep them desktop-only.
	const showDevtools = env.VITE_APP_ENVIRONMENT === "local" && !isMobile;

	return (
		<>
			<BrowserCompatibilityBanner />
			<Outlet />
			{showDevtools &&
				<TanStackRouterDevtools position="bottom-left" /> >
				<ReactQueryDevtools buttonPosition="bottom-right" />}
		</>
	);
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: RootComponent,
});
